export default __webpack_public_path__ + "static/media/MattLorenz.f7081430.jpg";